import FizConfig from "../FizConfig.ts";
import * as Html from "../util/Html.ts";

declare const google: any;

  // This is an implementation of the interface google.maps.OverlayView
  function MarkerConstructor(this: any, familyMap: any, address: any, place: any, locations: any[]){
    this.familyMap = familyMap;
    this.coordinates = new google.maps.LatLng(
        address.latitude,
        address.longitude
      );
    this.place = place;
    this.locations = locations;
    this.div = document.createElement('DIV');
  };

  // implements inheritance
  MarkerConstructor.prototype = new google.maps.OverlayView();
  Object.assign(MarkerConstructor.prototype,{
    onAdd(){
      import("./map_marker_html.mustache").then((mapMarkerTpl: any)=>{
        Html.setHtml(this.div,mapMarkerTpl,{
          panicButtonActivated : this.locations.filter((m: any) => m.panicButtonActivated).length > 0,
          locations: this.locations,
          place : this.place
        });

        this.div.style.position = 'absolute';
        this.div.style.transform ='translateZ(0px)';
        this.draw();

        this.getPanes().floatPane.appendChild(this.div);
      })
    },

    draw(){
      // Converts latitude and longitude coordinates to pixel.
      // adjusting the position of the overlap
      var
        position =
          this.getProjection().fromLatLngToDivPixel(this.coordinates);
      this.div.style.left = position.x + 'px';
      this.div.style.top = position.y + 'px';
    },

    onRemove(){
      try{
        this.div.parentNode.removeChild(this.div);
      }catch(e){}
      this.div = null;
    },

    bringToFront(bool: boolean) {
      if (bool){
        this.div.style ["z-index"] = "10";
      } else {
        this.div.style ["z-index"] = "";
      }
    }
  });


  var
    // Declare aliases
    markers: any[] = [],
    currentMap: any;

  function getDistanceInKm(latLng1: any, latLng2: any): number {
    var
      // 1 degree in radian, used for conversion from degrees to radians
      DEGREE_IN_RADIAN = Math.PI/180,
      // average earth radius in kilometers
      AVERAGE_EARTH_RADIUS_IN_KM = 6365,

      lat1InRad = latLng1.lat() * DEGREE_IN_RADIAN,
      lng1InRad = latLng1.lng() * DEGREE_IN_RADIAN,
      lat2InRad = latLng2.lat() * DEGREE_IN_RADIAN,
      lng2InRad = latLng2.lng() * DEGREE_IN_RADIAN;

    return AVERAGE_EARTH_RADIUS_IN_KM * Math.acos(
      Math.sin(lat1InRad) * Math.sin(lat2InRad) +
      Math.cos(lat1InRad) * Math.cos(lat2InRad) *
      Math.cos( lng2InRad - lng1InRad )
    );
  }
  function getSquareDim(latLng1: any, latLng2: any): {height: number, width: number} {
    var
      // 1 degree in radian, used for conversion from degrees to radians
      DEGREE_IN_RADIAN = Math.PI/180,
      // average earth radius in kilometers
      AVERAGE_EARTH_RADIUS_IN_KM = 6365,
      //the more we are far from equator, the more longitude diff causes less kilometers
      closestEquatorLatitude = Math.abs(latLng1.lat())<Math.abs(latLng2.lat())?latLng1.lat():latLng2.lat(),
      height = AVERAGE_EARTH_RADIUS_IN_KM * ((latLng1.lat()-latLng2.lat()) * DEGREE_IN_RADIAN),
      //handle that the earth is round
      lngDiffIndegree = Math.abs(latLng1.lng()-latLng2.lng())%180,
      width = Math.cos(closestEquatorLatitude * DEGREE_IN_RADIAN)*AVERAGE_EARTH_RADIUS_IN_KM * (lngDiffIndegree * DEGREE_IN_RADIAN);

    return {
      height:Math.abs(height),
      width:Math.abs(width)
    };
  }

  function getBarycenter(coordinatesList: any[]): any {
    var
      latitudeTotal = 0,
      longitudeTotal = 0,
      total = 0;

    coordinatesList.forEach(function (coordinates) {
      latitudeTotal += coordinates.lat ();
      longitudeTotal += coordinates.lng ();
      total++;
    });
    if (total === 0) {
      return null;
    }
    return new google.maps.LatLng (
      latitudeTotal / total,
      longitudeTotal / total
    );
  }

  function getCoordinatesList(locationsByAccountId: any): any[] {
    var list: any[] = [];
    Object.entries(locationsByAccountId).forEach(([accountId, location]: [string, any]) => {
      if(location.address){
        list.push(
            new google.maps.LatLng (
              location.address.latitude,
              location.address.longitude
            )
          );
      }

    });
    return list;
  }

  function getCenterArea(locationsByAccountId: any): any {
    var
      // maximum radius from center, in kilometers
      MAXIMUM_RADIUS_IN_KM = 50,

      coordinatesList: any[],
      totalCheckins: number,
      barycenter: any,
      center: any,
      coordinates: any,
      familyArea: any,
      i: number;

    coordinatesList = getCoordinatesList(locationsByAccountId);
    totalCheckins = coordinatesList.length;
    if (totalCheckins === 0){
      return null;
    }

    barycenter = getBarycenter(coordinatesList);

    // sort by distance from the barycenter
    coordinatesList.sort(function(a,b){
      return (
        getDistanceInKm(a,barycenter) -
        getDistanceInKm(b,barycenter)
      );
    });

    // center family area on the family member closest to the barycenter
    center = coordinatesList[0];
    familyArea = new google.maps.LatLngBounds (center,center);

    if (totalCheckins === 1){
      return familyArea;
    }

    // enlarge family area to the second family member
    familyArea.extend(coordinatesList[1]);

    // enlarge family area to other family members closer than 50km
    for (i=2; i<totalCheckins; i++){
      coordinates = coordinatesList[i];
      if ( getDistanceInKm(coordinates,center) < MAXIMUM_RADIUS_IN_KM ){
        familyArea.extend(coordinates);
      } else {
        return familyArea;
      }
    }
    return familyArea;
  }

  function getZoomFor(familyArea: any, node: HTMLElement): number {
    var
      dim = getSquareDim(
        familyArea.getNorthEast(),
        familyArea.getSouthWest()
      ),
      //si mon noeud est plus grand je peut zoomer plus
      zoomWidth = 6.5+ Math.log(node.offsetWidth/dim.width) / Math.log(2),
      zoomHeight = 6.5+ Math.log(node.offsetHeight/dim.height) / Math.log(2)
      ;
//    console.log(zoomWidth,node.offsetWidth,dim.width)
//    console.log(zoomHeight,node.offsetHeight,dim.height)
    return Math.max(1,Math.min(16,Math.floor(Math.min(zoomWidth,zoomHeight))));

  }

  function addFamilyPlacesMarkers(familyMap: any, googleMap: any, locationsByAccountId: any, places: any[]): void {
    //clear markers
    markers = [];
    places.forEach((place: any)=>{
      var
        membersLocation: any[] = [],
        marker: any;
      //onc cherche les memebre qui sont dans la place
      Object.entries(locationsByAccountId).forEach(([i, location]: [string, any]) => {
        if(location.placeId===place.placeId){
          membersLocation.push(location);
        }
      });
      marker = new (MarkerConstructor as any)(familyMap,place.address,place,membersLocation);
      marker.setMap (googleMap);
      markers.push (marker);
    });

    //handle all accounts on temporary places
    Object.entries(locationsByAccountId).forEach(([i, location]: [string, any]) => {
      var marker: any;
      if(location.place){
        //only for tempory place else it is handl previously by place displaying
        if(location.place.isTemporary){
          marker = new (MarkerConstructor as any)(familyMap,location.place.address,null,[location.author()]);
          marker.setMap (googleMap);
          markers.push (marker);
        }
      //for people not on place
      }else{
        marker = new (MarkerConstructor as any)(familyMap,location.address,null,[location.author()]);
        marker.setMap (googleMap);
        markers.push (marker);
      }
    });

  }

  function FamilyMap(this: any, node: HTMLElement, locationsByAccountId: any, places: any[], withoutMarkers?: boolean){
    var
      // instance of google.maps.LatLngBounds,
      // or null when there are no check-ins yet
      familyArea = getCenterArea(locationsByAccountId)||getCenterArea(places),
      defaultCenter = new google.maps.LatLng(FizConfig.defaultLocation.latitude,FizConfig.defaultLocation.longitude),
      // instance of google.maps.Map
      googleMap: any,
      wallIds: any[],
      pathCache: any,
      currentCircle: any;


    googleMap = new google.maps.Map (node, {
      zoom: familyArea==null?FizConfig.defaultLocation.zoom:getZoomFor(familyArea,node),
      minZoom: 3,
      center: familyArea==null?defaultCenter:familyArea.getCenter(),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      streetViewControl: false,
      zoomControl: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP,
        style: google.maps.ZoomControlStyle.LARGE
      },
      scaleControl: true,
      draggable: true,
      disableDefaultUI: true,
      disableDoubleClickZoom: true,
    });
    this.addZoom = (delta: number)=>{
      googleMap.setZoom(googleMap.getZoom()+delta);
    }
    //for hiding restaurant and other business stuffs
    //googleMap.setOptions({styles:[{featureType: "poi",stylers: [{ visibility: "off" }]}]});
    currentMap = googleMap;
    function refresh(positionById: any, places: any[]): void {
      //start by removing accuracy circle
      if(currentCircle){
        currentCircle.setMap(null);
        currentCircle = null;
      }

      locationsByAccountId = {};
      wallIds = [];
      Object.entries(positionById).forEach(([id, position]: [string, any]) => {
        if(position.wallMessageId){
          wallIds.push(position.wallMessageId);
        }
        if(position.address){
          locationsByAccountId[id]=position;
        }
      });
      if (!withoutMarkers) {
        //clean previous markers
        markers.forEach(function(marker: any){
          marker.setMap(null);
        });
        //recrete them
        addFamilyPlacesMarkers(this,googleMap,locationsByAccountId,places);
      }
    }
    refresh(locationsByAccountId,places);

    function centerAddress(address: any, showRadius?: boolean): void {
      var latlng = (address instanceof google.maps.LatLng)?address:new google.maps.LatLng(address.latitude,address.longitude);
      googleMap.panTo(latlng);

      if(currentCircle){
        currentCircle.setCenter(latlng);
        currentCircle.setRadius(address.radius);
        currentCircle.setVisible(showRadius);

      }else{
        currentCircle = new google.maps.Circle({
          map: googleMap,
          strokeColor: '#2376AC',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#2376AC',
          fillOpacity: 0.35,
          center: latlng,
          radius: address.radius,
          visible:showRadius
        });
      }

    }

    function centerPlace (place: any): void {
      var
        marker: any,
        i: number;

      for (i = 0; i < markers.length; i++) {
        marker = markers [i];
        if ( marker.place && marker.place.placeId === place.placeId ) {
          marker.bringToFront (true);
        }
      }

      if (!place || !place.address){
        return;
      }
      centerAddress(place.address,false);
    }

    function triggerResize (): void {
      if(googleMap){
        var
          map_zoom = googleMap.getZoom (),
          map_center = googleMap.getCenter ();

        google.maps.event.trigger (googleMap, 'resize');
        googleMap.setZoom (map_zoom);
        googleMap.setCenter (map_center);
      }
    }

    function centerFamilyMember (location: any): void {
      if(googleMap===null){
        setTimeout(function(){centerFamilyMember(location);},1000);
        return;
      }
      if (!location || !location.address){
        var centerArea = getCenterArea(locationsByAccountId);
        if(centerArea){
          centerAddress(centerArea.getCenter(),false);
          var newzoom = getZoomFor(centerArea,node);
          if(googleMap.getZoom()>newzoom){
            googleMap.setZoom(newzoom);
          }
        }
      }else{
        centerAddress (location.address,location.placeId==null);
        for (var i = 0; i < markers.length; i++) {
          var marker = markers [i];
          if ( marker.locations) {
            marker.locations.forEach(function(profile: any){
              if(profile.accountId===location.accountId){
                marker.bringToFront (true);
              }
            });
          }
        }
      }
    }

    function buildPath(locations: any[]): void {
      var
        pathMarkers: any[] = [],
        latLngs: any[] = [],
        circles: any[] = [],
        i: number,
        location: any,
        polyline: any;
      pathCache = {};
      for(i =0; i<locations.length; i++){
        location = locations[i];
        latLngs[i] = new google.maps.LatLng(
          location.address.latitude,
          location.address.longitude
        );
        pathMarkers[i] = new google.maps.Marker({
          map: googleMap,
          position: latLngs[i],
          title: location.time
        });
        circles[i] = new google.maps.Circle({
          map: googleMap,
          center: latLngs[i],
          radius: location.address.radius,
          visible:false,
          fillColor: '#000066'
        });
        pathCache [location.time] = {
          marker:pathMarkers [i],
          latLng:latLngs [i],
          circle:circles [i]
        };
      }
      polyline = new google.maps.Polyline({map: googleMap,path:latLngs});
    }

    function showPathPoint(time: string): void {
      if(currentCircle) {
        currentCircle.setVisible(false);
      }
      currentCircle = pathCache[time].circle;
      currentCircle.setVisible(true);
      googleMap.panTo(pathCache[time].latLng);
    }

    function destroy(): void {
      wallIds = null;
      pathCache = null;
      currentCircle = null;
      // There is no method available to destroy an instance of map.
      // This is the closest we can get according to [2].
      //
      // Reference:
      // [2] GUnload() a single Google Map
      // http://stackoverflow.com/a/1943425/207968
      if(googleMap){
        googleMap.controls.forEach(function(control: any){
          if (control && control.clear){
            control.clear();
          }
        });
        google.maps.event.clearInstanceListeners(googleMap);
      }
      googleMap = null;
    }

    // Public API
    this.centerAddress = centerAddress;
    this.centerPlace = centerPlace;
    this.centerFamilyMember = centerFamilyMember;
    this.showPathPoint = showPathPoint;
    this.buildPath = buildPath;
    this.triggerResize = triggerResize;
    this.destroy = destroy;
    this.refresh = refresh;
  }

  function createMap(locationByAccountId: any, places: any[], withoutMarkers?: boolean): any {
    return new (FamilyMap as any)(
      document.getElementById("map-familyMap"),
      locationByAccountId,
      places,
      withoutMarkers
    );
  }


function getCenter(): any {
  try{
    return currentMap.getCenter();
  }catch(e){
    return null;
  }
}
function getZoom(): number {
  try{
    return currentMap.getZoom();
  }catch(e){
    return 14;
  }
}
export {createMap,getCenter,getZoom}
